import { render, staticRenderFns } from "./pricenewFW.vue?vue&type=template&id=48246534&scoped=true"
import script from "./pricenewFW.vue?vue&type=script&lang=js"
export * from "./pricenewFW.vue?vue&type=script&lang=js"
import style0 from "./pricenewFW.vue?vue&type=style&index=0&id=48246534&prod&scoped=true&lang=css"
import style1 from "./pricenewFW.vue?vue&type=style&index=1&id=48246534&prod&lang=css"
import style2 from "./pricenewFW.vue?vue&type=style&index=2&id=48246534&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48246534",
  null
  
)

export default component.exports